import React, { useEffect, useState } from 'react';
import './Configuracion.css';
import { getToken, isSupported } from 'firebase/messaging';
import { messaging } from '../../config/firebase';
import secureAxios from '../../utils/secureAxios';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import NavInf from '../../components/NavInf/NavInf';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faLock } from '@fortawesome/free-solid-svg-icons';

const vapidKey = 'BL9Hx_1JRfrSusv698qSJJBpIEdSRlz0JLkBblwSxRx6jOai8OIc0enx6KEfQ2KKa2smi4TscsZJ-fv4HJqbjM0';

export default function Configuracion() {
    const [notificacionesActivas, setNotificacionesActivas] = useState(false);
    const [mensaje, setMensaje] = useState('');

    useEffect(() => {
        const activadas = localStorage.getItem('notificaciones-activadas') === 'true';
        setNotificacionesActivas(activadas);
    }, []);

    const toggleNotificaciones = async () => {
        if (notificacionesActivas) {
            // Desactivar
            localStorage.removeItem('notificaciones-activadas');
            setNotificacionesActivas(false);
            setMensaje('🔕 Notificaciones desactivadas.');
            return;
        }

        // Activar
        const soportado = await isSupported();
        if (!soportado) {
            setMensaje('❌ Este navegador no soporta notificaciones push.');
            return;
        }

        try {
            const permiso = await Notification.requestPermission();
            if (permiso !== 'granted') {
                setMensaje('❌ Debes permitir las notificaciones.');
                return;
            }

            const token = await getToken(messaging, { vapidKey });
            if (token && typeof token === 'string') {
                const cleanedToken = token.trim().replace(/^"|"$/g, '');

                await secureAxios.post('https://api.minymol.com/push/register-token', {
                    fcmToken: cleanedToken,
                });

                localStorage.setItem('notificaciones-activadas', 'true');
                setNotificacionesActivas(true);
                setMensaje('✅ Notificaciones activadas correctamente.');
            } else {
                setMensaje('⚠️ No se pudo obtener token válido.');
            }
        } catch (err) {
            console.error('Error activando notificaciones:', err);
            setMensaje('❌ Error al activar notificaciones.');
        }
    };

    return (
        <>
            <Header />
            <div className="config-container">
                <div className="config-option">
                    <span>Notificaciones</span>
                    <label className="switch">
                        <input type="checkbox" checked={notificacionesActivas} onChange={toggleNotificaciones} />
                        <span className="slider round"></span>
                    </label>
                </div>
                {mensaje && <p className="mensaje-config">{mensaje}</p>}

                <div className='user-buttons'>
                    <Link to="/cambiar-contrasena" className="user-button">
                        <span className="icon-left">
                            <FontAwesomeIcon icon={faLock} />
                        </span>
                        <span className="text">Cambiar contraseña</span>
                        <span className="icon-right">
                            <FontAwesomeIcon icon={faChevronRight} />
                        </span>
                    </Link>
                </div>
            </div>
            <NavInf />
            <Footer />
        </>
    );
}
